import { DOCUMENT_DISPLAY_NAME } from './documentConstants';
import { registerElementType } from '../elements/elementRegistry';
import elementConstructor from '../elements/elementConstructor';
import { ELEMENT_DISPLAY_MODES } from '../elements/elementDisplayModeConstants';
import { ElementType } from '../elements/elementTypes';

const objectConstructorFn = (params) => {
    const { content } = params;
    return {
        ...elementConstructor(params),
        elementType: ElementType.DOCUMENT_TYPE,
        content: {
            textContent: null,
            displayMode: ELEMENT_DISPLAY_MODES.ICON_VIEW,
            showMedia: false,
            ...content,
        },
    };
};

export default (params = {}) =>
    registerElementType({
        elementType: ElementType.DOCUMENT_TYPE,
        objectConstructorFn,
        displayName: DOCUMENT_DISPLAY_NAME,
        ...params,
    });
